export default "__VITE_ASSET__CcINcFAm__"